import { eTextures, Game } from "../../Game";
import { Gameplay, TIMER } from "../Gameplay";
import { HUD } from "./HUD";
import { ScreenOverlay } from "./ScreenOverlay";

const enum eManCityIntroState {
    off,
    idle,
    delay,
    hide,
}



export class ManCityIntro {
    /**
     * Udalost vyvolana po ukonceni intra
     * Emitter: Gameplay.events
     */
    static readonly EVENT_COMPLETE = "intro:complete";

    private _logoEnt: pc.Entity;
    private _overlay: ScreenOverlay;

    private _displayLen: number;

    private _state: eManCityIntroState;
    private _stateTime: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(screen: pc.GraphNode, screenOverlay: ScreenOverlay) {
        // Zobrazeni loga
        this._logoEnt = new pc.Entity();
        this._logoEnt.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            texture: Game.app.assets.find(eTextures.manCityLogo, pc.eAssetType.texture).resource,
            width: 378,
            height: 378,
            anchor: [0.5, 0.5, 0.5, 0.5],
            pivot: [0.5, 0.5],
        });

        this._logoEnt.enabled = false;
        screen.addChild(this._logoEnt);

        // Ulozit overlay
        this._overlay = screenOverlay;

        // Stav
        this._state = eManCityIntroState.off;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    show(): void {
        this._overlay.opacity = 1;
        this._overlay.color = new pc.Color(0, 0, 0);
        this._overlay.enabled = true;

        this._logoEnt.enabled = true;

        this._state = eManCityIntroState.idle;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    start(displayLen: number): void {
        this._displayLen = displayLen;
        this._state = eManCityIntroState.delay;
        this._stateTime = TIMER.time;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    hide(): void {
        if (this._state == eManCityIntroState.delay) {
            this._state = eManCityIntroState.hide;
            this._stateTime = TIMER.time;
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._logoEnt.enabled = false;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        switch (this._state) {
            case eManCityIntroState.off:
            case eManCityIntroState.idle: {
                return;
            }
            case eManCityIntroState.delay: {
                if (TIMER.time - this._stateTime < this._displayLen)
                    break;

                this.hide();
            }
            default: {
                let progress = (TIMER.time - this._stateTime) / 750;

                if (progress >= 1) {
                    this._overlay.enabled = false;
                    this._logoEnt.enabled = false;

                    this._state = eManCityIntroState.off;

                    Gameplay.instance.events.fire(ManCityIntro.EVENT_COMPLETE);

                    break;
                }

                let opacity = 1 - pc.SineOut(progress);

                this._overlay.opacity = opacity;
                this._logoEnt.element.opacity = opacity;

                break;
            }
        }
    }
}